const Banner728x90 = ({ refLink }) => (
  <a href={refLink} target="_blank" rel="noopener noreferrer" className="sc-banner-728 block" aria-label="1SimpleCycler 3.0 — Join & Cycle">
    <div className="sc-banner-728-inner">
      <img src="/logo/logo-728.png" alt="1SimpleCycler 3.0" className="sc-banner-728-logo" width="273" height="36" />
      <div className="sc-banner-728-marquee">
        <div className="sc-banner-728-marquee-track">
          <span>CRITICAL UPDATE: There is absolutely NO &lsquo;NEXT IN LINE&rsquo; here! Shuffled randomly every 3 seconds! Sign up today, cycle today!</span>
          <span aria-hidden="true">
            CRITICAL UPDATE: There is absolutely NO &lsquo;NEXT IN LINE&rsquo; here! Shuffled randomly every 3 seconds! Sign up today, cycle today!
          </span>
        </div>
      </div>
      <span className="sc-banner-728-cta">Join &amp; Cycle</span>
    </div>
  </a>
);

export default Banner728x90;
